import { Divider, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import ButtonBackground from "images/button-background.svg";
import React, { useState } from "react";
import * as FP from "utils/fp-js";
import { useReferralButton } from "./ReferralButton.hook";
import {
  ButtonContainer,
  ButtonIndicator,
  Container,
  Label,
  Led,
  LogoHolder,
  LogoSplash,
  Prop,
  TextMosaic,
  Value,
  Logo,
  EmptyLogoHolder,
  HalfHolder,
} from "./SmallReferralButton.style";
import { modes } from "./ReferralButton";
import { ReactComponent as SendersIcon } from "images/providers-icon.svg";
import { ReactComponent as SendersActiveIcon } from "images/providers-active-icon.svg";
import { ReferralForm } from "./ReferralForm/ReferralForm";

export const SmallReferralButton = ({
  data,
  setError,
  setCurrentButton,
  logo,
  mode,
  setNewLevel,
  setNewProgress,
  setNewCountsForUpdate,
  setLevelProgress,
  showWarning,
  hideWarning,
  originator,
  providers = [],
}) => {
  const [newReferral, setNewReferral] = useState(null);

  const {
    state,
    createNewReferral,
    handleReferralButtonClick,
    recipient,
    accessToken,
    isSendersSelected,
    isReferralSending,
  } = useReferralButton({
    data,
    setError,
    setNewLevel,
    setNewProgress,
    setNewCountsForUpdate,
    setLevelProgress,
    originator,
    setNewReferral,
  });

  return (
    <div className="p-0 sm:p-8 border-0 sm:border-4 rounded-3xl border-dashed flex flex-col justify-start items-center">
      <Container>
        <ButtonContainer
          sx={{
            backgroundImage:
              logo && mode === modes.Skin
                ? `url("${logo}")`
                : `url("${ButtonBackground}")`,
          }}
        >
          {/* {!recipient?.isFlowSimplified && (
            <Stack
              alignItems={"flex-end"}
              sx={{
                margin: 0,
                position: "absolute",
                top: "-10px",
                right: "-10px",
              }}
            >
              <ActionMenu
                items={[
                  {
                    label: "View Details",
                    onClick: () => setSelectedButton(data[locationId]),
                  },
                ]}
              />
            </Stack>
          )} */}
          {FP.match(true)
            .on(
              mode === modes.Logo && !!logo,
              <Logo
                sx={{
                  backgroundImage: `url("${logo}")`,
                }}
              />
            )
            .on(
              mode === modes.Half && !!logo,
              <>
                <EmptyLogoHolder />
                <HalfHolder
                  sx={{
                    backgroundImage: `url("${logo}")`,
                  }}
                />
              </>
            )
            .otherwise(
              <>
                {logo ? (
                  <LogoSplash />
                ) : (
                  <LogoHolder>
                    <TextMosaic>
                      {[...Array(20)].map((value, index) => (
                        <React.Fragment key={`${accessToken}-${index}`}>
                          {recipient?.name}&nbsp;
                        </React.Fragment>
                      ))}
                    </TextMosaic>
                  </LogoHolder>
                )}
              </>
            )}
          <Led className={state} />
          <ButtonIndicator
            onClick={createNewReferral}
            className={state}
          >
            {isReferralSending && <CircularProgress />}
          </ButtonIndicator>
        </ButtonContainer>
        {providers?.map(({ id, name, speciality }) => (
          <Prop key={`${id}-in-button`}>
            <Label>Provider: </Label>
            <Value>{[name, speciality].filter(Boolean).join(", ")}</Value>
          </Prop>
        ))}
        <Divider />
        <Prop>
          <Label>Practice: </Label>
          <Value>{recipient?.name}</Value>
        </Prop>
        <Divider />
        <Prop>
          <Label>Phone: </Label>
          <Value>{recipient?.phone}</Value>
        </Prop>
        <Tooltip title={"Manage Senders"}>
          <button
            onClick={() => setCurrentButton(data)}
            className="absolute -top-1 -left-2 w-8 h-8 p-1 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 focus:outline-none"
          >
            {isSendersSelected ? <SendersActiveIcon /> : <SendersIcon />}
          </button>
        </Tooltip>
      </Container>
      {!!newReferral && (
        <ReferralForm
          newReferral={newReferral}
          setNewReferral={setNewReferral}
          handleReferralButtonClick={handleReferralButtonClick}
          originator={originator}
        />
      )}
    </div>
  );
};
